import { styled } from "styled-components";

import { colorsPalettes, setElevation } from "@similarweb/styles";
import { Card } from "@similarweb/ui-components";
import { Flex, Stack } from "@similarweb/ui-components/foundations";

export const BorderCard = styled(Card)`
    border: 1px solid ${colorsPalettes.carbon[100]};
    box-shadow: none;
    border-radius: 6px;
    position: relative;
    cursor: pointer;
    display: flex;
    flex-direction: column;

    &:hover {
        ${setElevation("Z2")};
    }
`;

export const ImageContainer = styled(Stack)`
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
`;

export const CreativeImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: contain;
`;

export const FooterWrapper = styled(Flex)`
    justify-content: space-between;
    align-items: center;
    background-color: ${colorsPalettes.carbon[25]};
    padding: 2px 8px;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
`;

export const Logo = styled.img`
    border-radius: 50%;
    width: 32px;
    height: 32px;
`;
